import type { MdtDispatch } from '../types';
import { playDispatchAlertSound } from './dispatchAlertSound';

/** Pick the most recent pending dispatch for this unit. */
export function latestPendingDispatch(list: MdtDispatch[]): MdtDispatch | null {
  const pending = list.filter((d) => d.status === 'pending');
  if (pending.length === 0) return null;
  return pending.sort(
    (a, b) => new Date(b.dispatchedAt).getTime() - new Date(a.dispatchedAt).getTime()
  )[0];
}

/** Vibrate + system notification + alarm tone for an incoming dispatch. */
export function alertIncomingDispatch(d: MdtDispatch): void {
  void playDispatchAlertSound();

  try {
    if (typeof Notification !== 'undefined' && Notification.permission === 'granted') {
      const n = new Notification(`Incoming Dispatch — ${d.incidentSeverity?.toUpperCase() || ''}`, {
        body: `${d.incidentTitle}\n${d.incidentLocation?.address || ''}`,
        tag: `dispatch-${d.id}`,
        requireInteraction: true,
        icon: '/icons/icon-192x192.png',
        badge: '/icons/icon-192x192.png',
      });
      n.onclick = () => {
        window.focus();
        n.close();
      };
    }
  } catch { /* ignore */ }
}
